import { InjectionToken } from '@angular/core';

export const GOOGLE_MAP_API_KEY = new InjectionToken<string>(
  'google-map-api-key',
);
